export const EXERCISES_PATH = "exercises/";
export const SETS_PATH = "sets/";
export const WORKOUTS_PATH = "workouts/";
export const WORKOUT_PLANS_PATH = "workoutPlans/";
export const USERS_PATH = "users/";
